import filterByArraySchema from '../infrastructure/utils/filterByArraySchema';
import { citySchema } from '../schemas/CitySchema';
import { City } from '../types/City';

const parseCities = filterByArraySchema<City>(citySchema);

export default parseCities;
